export default "__VITE_ASSET__DiJEJvet__"